var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSea04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0847168,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#D9894F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3224_14264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0847168,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3224_14264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.963 90.7147L214.513 88.6375C213.16 87.4903 211.041 87.7668 209.779 89.255L122.952 191.654C121.691 193.142 121.764 195.278 123.117 196.426L125.567 198.503C126.92 199.65 129.04 199.373 130.302 197.885L217.128 95.4865C218.39 93.9983 218.316 91.8619 216.963 90.7147Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.963 90.7147L214.513 88.6375C213.16 87.4903 211.041 87.7668 209.779 89.255L203.547 96.6042L210.896 102.836L217.128 95.4865C218.39 93.9983 218.316 91.8619 216.963 90.7147Z",
    fill: "#FCFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.682 170.314L158.896 149.266L188.009 114.931L195.358 121.163L153.682 170.314Z",
    fill: "#171F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.601 97.7131L147.098 118.485L142.933 123.397C142.575 123.818 141.944 123.87 141.523 123.513L118.551 104.035C118.13 103.678 118.078 103.047 118.435 102.625L122.601 97.7131Z",
    fill: "#33449A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09 160.028L220.587 180.8L216.422 185.712C216.065 186.134 215.434 186.186 215.012 185.828L192.041 166.35C191.619 165.993 191.567 165.362 191.925 164.941L196.09 160.028Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.095 118.49L196.065 160.014L191.9 164.926C191.543 165.347 190.912 165.399 190.491 165.042L143.046 124.812C142.624 124.455 142.572 123.824 142.93 123.402L147.095 118.49Z",
    fill: "#9BA9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.936 95.2212C208.936 95.2212 215.834 136.948 196.069 160.109L220.541 180.86C243.494 153.79 236.006 118.174 208.936 95.2212Z",
    fill: "#33449A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.935 95.2204C181.865 72.2675 145.483 70.7269 122.551 97.7719L147.024 118.523C166.618 95.2164 208.935 95.2204 208.935 95.2204Z",
    fill: "#9BA9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.991 77.7688C178.707 77.3041 195.046 83.4439 208.934 95.2196C208.934 95.2196 191.465 95.218 173.777 101.399C166.201 91.4069 163.43 81.4822 162.991 77.7688Z",
    fill: "#C3CCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.734 137.629C231.581 122.054 222.811 106.963 208.891 95.2255C208.891 95.2255 211.796 112.452 208.64 130.92C219.752 136.73 230 137.814 233.734 137.629Z",
    fill: "#5167D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.917 95.24L208.935 95.2192L208.911 95.1984C208.911 95.1984 208.913 95.2124 208.917 95.24ZM171.446 139.234L147.024 118.526C154.054 110.164 164.002 104.798 173.869 101.353C191.506 95.1971 208.886 95.1817 208.886 95.1817L190.937 116.351L208.917 95.24C209.155 96.7207 215.47 137.369 196.043 160.086L195.994 160.045L171.444 139.237L171.446 139.234Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.869 101.353C191.506 95.1965 208.886 95.1811 208.886 95.1811L190.192 117.229L173.869 101.353Z",
    fill: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.524 130.735C211.714 112.329 208.887 95.18 208.887 95.18L190.193 117.228L208.524 130.735Z",
    fill: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.52,
    cy: 83.1475,
    r: 14.4689,
    transform: "rotate(-4.7046 253.52 83.1475)",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.753 242.896V223.099H189.518C194.016 223.099 196.6 225.875 196.6 229.771C196.6 233.722 193.975 236.443 189.409 236.443H185.854V242.896H181.753ZM185.854 233.135H188.753C191.186 233.135 192.376 231.767 192.362 229.771C192.376 227.802 191.186 226.476 188.753 226.463H185.854V233.135ZM200.565 243.142C199.28 243.142 198.241 242.117 198.268 240.845C198.241 239.588 199.28 238.562 200.565 238.576C201.782 238.562 202.835 239.588 202.835 240.845C202.835 242.117 201.782 243.142 200.565 243.142ZM206.171 242.896V223.099H213.936C218.434 223.099 221.018 225.875 221.018 229.771C221.018 233.722 218.393 236.443 213.827 236.443H210.272V242.896H206.171ZM210.272 233.135H213.171C215.604 233.135 216.794 231.767 216.78 229.771C216.794 227.802 215.604 226.476 213.171 226.463H210.272V233.135ZM227.581 223.099V242.896H223.534V223.099H227.581ZM237.452 243.197C232.899 243.183 230.11 240.244 230.124 235.541C230.11 230.961 232.94 227.857 237.288 227.857C241.184 227.857 244.26 230.318 244.26 235.377V236.525H234.116C234.116 238.767 235.442 240.148 237.534 240.162C238.915 240.148 239.899 239.547 240.296 238.658H244.151C243.577 241.406 241.116 243.183 237.452 243.197ZM234.116 233.982H240.432C240.419 232.177 239.175 230.879 237.37 230.892C235.51 230.879 234.198 232.273 234.116 233.982Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSea04);
export default __webpack_public_path__ + "static/media/mini_sea_04.d8640cbd14fca19e0b891db5454108bf.svg";
export { ForwardRef as ReactComponent };